export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-later-de-5ff65626.svg'